var app = angular.module("leonardo");

var TaskCannotDoDialog = function($scope, $rootScope, $q, ngDialog, NoteService, FormErrorsService, TaskService,
                                  PermissionService, DynamicFormDataRestService, AttachmentService, AnalyticsService,
                                  StatsigService, WorkOrderProviderService, AuthDataService) {
  $scope.task = $scope.ngDialogData.task;
  $scope.is_mrb = $scope.ngDialogData.is_mrb;
  $scope.taskService = TaskService;
  $scope.permissionService = PermissionService;
  $scope.data = {};
  $scope.attachments = [];
  $scope.errorMessage = '',

  $scope.removeAttachment = function(index) {
    $scope.attachments.splice(index, 1);
  };

  $scope.showAttachDialog = function() {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/attachment/upload.html',
      controller: 'AttachmentUploadDialog',
      data: { task: {}, mode: 'upload_note' }
    }).then(function(attachments) {
      angular.forEach(attachments, function(attachment) {
        $scope.attachments.push(attachment);
      });
    });
  };

  $scope.showCreateWorkOrder = async function () {
    var didActivateGate = false;
    function cleanupGate() {
      if (didActivateGate) {
        StatsigService.deactivateContextualGate('work_orders_new_experience');
        didActivateGate = false;
      }
    }
    try {
      var inIframe = false;
      try {
        inIframe = window.self !== window.top;
      } catch (e) {
        inIframe = true;
      }

      const useNewExperience = inIframe ? true : await StatsigService.checkGate('work_orders_new_experience');

      if (!inIframe && useNewExperience) {
        StatsigService.activateContextualGate('work_orders_new_experience');
        didActivateGate = true;
      }
      
      WorkOrderProviderService.openWorkOrder({
        useExpoIntegration: useNewExperience,
        action: 'create',
        data: {
          task: $scope.task,
          property: $scope.task.property,
          unit: $scope.task.unit_id
        },
        closeCallback: function(result) {
          cleanupGate();
        }
      }).catch(function() {
        cleanupGate();
      });
    } catch (error) {
      console.error('[WORK_ORDER] Failed to open work order:', error);
      cleanupGate();
    }
  };

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    var data = angular.copy($scope.data);
    data['attachments'] = [];
    data['actionitem_set'] = [];
    data['actionitem_set'].push($scope.task.id);
    var dynamic_form_data_id = $scope.task.dynamic_form_data && $scope.task.dynamic_form_data.id ?
      $scope.task.dynamic_form_data.id : $scope.task.dynamic_form_data;
    if (dynamic_form_data_id) {
      ngDialog.openConfirm({
        template: 'views/templates/dialog/task/skip-form.html',
        controller: 'SkipFormDialog',
        data: {
          task: $scope.task
        }
      }).then(function() {
        DynamicFormDataRestService.one(dynamic_form_data_id).remove({force_delete_document_file:true}).then(function(){
          $scope.task['dynamic_form_data'] = null;
          $scope.cannotdotask(data);
        });
      }, function () {
        return;
      });
    }
    else {
      $scope.cannotdotask(data);
    }
  };

  $scope.cannotdotask = function (data) {
    // Step 1: Call Cannot Do API first
    var createdAttachmentIds = [];
    $scope.task.cannotDo().then(function (data_result) {
      $scope.task.status = data_result.status;
      AnalyticsService.track("Task Marked Complete", {
        ...AnalyticsService.getTaskGroupProperties(data_result),
        cannot_do : true,
        copy_supervisor : data.important || false,
        days_late : AnalyticsService.calculateDaysLate(data_result.due_date) 
      })
      if (data_result.workflow_status == 5 && data_result.can_launch_trigger_wfs) {
        $scope.launchWorkflow(data_result);
      }
      // Step 2: Call Attachment API
      var attachmentPromises = angular.forEach($scope.attachments, function (attachment) {
        if (attachment.document_folder || attachment.document_file) {
          return AttachmentService.linkTo(attachment, $scope.task.id).then(function (response) {
            createdAttachmentIds.push(response.data.id);
            data['attachments'].push(response.data.id);
          }).catch(function () {
            // undone cannot do
            $scope.task.reopen({});
            // Handle error for Attachment API
            $scope.errorMessage = "We were unable to add your attachment. Please try again.";
            throw new Error("Attachment API failed");
          });
        } else if (attachment.link) {
          return AttachmentService.post(attachment.name, null, attachment.link, attachment.available_for_account, $scope.task.id)
            .then(function (response) {
              createdAttachmentIds.push(response.data.id);
              data['attachments'].push(response.data.id);
            }).catch(function () {
              // undone cannot do
              $scope.task.reopen({});
              // Handle error for Attachment API
              $scope.errorMessage = "We were unable to add your attachment. Please try again.";
              throw new Error("Attachment API failed");
            });
        } else {
          return AttachmentService.post(attachment.name, attachment.file, null, attachment.available_for_account, $scope.task.id)
            .then(function (response) {
              createdAttachmentIds.push(response.data.id);
              data['attachments'].push(response.data.id);
            }).catch(function () {
              // undone cannot do
              $scope.task.reopen({});
              // Handle error for Attachment API
              $scope.errorMessage = "We were unable to add your attachment. Please try again.";
              throw new Error("Attachment API failed");
            });
        }
      });
      return $q.all(attachmentPromises); // Wait for all attachments to complete
    }).then(function () {
      // Step 3: Call Notes API
      return NoteService.post({
        text: data.text,
        important: data.important,
        actionitem_set: [$scope.task.id],
        attachments: createdAttachmentIds // Attachments are passed here
      }).then(function (note) {
        $scope.task.notes.push(note);
      }).catch(function () {
        // undone cannot do
        $scope.task.reopen({});
        // Handle error for Notes API
        $scope.errorMessage = "We were unable to add your note. Please try again.";
        // Cleanup created attachments if Notes API fails
        var deleteAttachmentPromises = createdAttachmentIds.map(function (id) {
          return AttachmentService.delete(id)
        });
        return $q.all(deleteAttachmentPromises).finally(function () {
          throw new Error("Notes API failed");
        });
      });
    }).then(function () {
      $scope.closeThisDialog();
      $rootScope.$broadcast('task-cannot-do-dialog:success', $scope.task);
    }).catch(function (error) {
      FormErrorsService.goToError();
    })
  };

  $scope.closeCannotDoDialog = function(){
    $scope.closeThisDialog();
    if($scope.errorMessage){
      $rootScope.$broadcast('close-unit-dynamic-form', $scope.task); // Broadcast event at the end
    }
  }
 
 
  $scope.launchWorkflow = function(result) {
    var items_ids = result.workflow_instance.active_templates.map(value => value.id);
    ngDialog.openConfirm({
      template: 'views/templates/dialog/workflow/launch.html',
      controller: 'LaunchWorkFlowDialog',
      data: {
        workflow: result.workflow_instance,
        items: items_ids,
        property: result.property,
        unit: result.workflow_instance.unit?.id || null,
        workflow_id: result.workflow_instance.workflow,
        is_launch_trigger_wfs: true,
        is_mrb: $scope.is_mrb,
        context: 'Tasks Page'
      }
    });
    $scope.closeThisDialog();
  };
};
 
app.controller('TaskCannotDoDialog', [
  '$scope', '$rootScope', '$q', 'ngDialog', 'NoteService', 'FormErrorsService',
  'TaskService', 'PermissionService', 'DynamicFormDataRestService', 'AttachmentService', 'AnalyticsService',
  'StatsigService', 'WorkOrderProviderService', 'AuthDataService', TaskCannotDoDialog
]);
 